import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import {
  reduxForm,
  FieldArray,
  getFormValues,
  Field,
  arrayPush,
  isValid,
  change,
  arrayRemoveAll,
} from 'redux-form';
import classNames from 'classnames/bind';
import { connect } from 'react-redux';

// import * as clevertapItem from 'clevertap/inventory/item';
import withFeatureFlag from 'hocs/withFeatureFlags';
import ModalHeader from 'components/Modal/ModalHeader';
import TooltipCommerceStore from 'components/TooltipCommerce';
import Switch from 'components/Fields/ReduxForm/Switch';
import * as actItem from 'actions/library/item';

import ItemVariantFieldArray from './ItemVariantFieldArray';
import TypeFieldArrayEcommerce from './TypeFieldArrayEcommerce';
import styles from './ItemVariantModal.css';

const cx = classNames.bind(styles);
const ECOMMERCECATEGORYID = 166;

const validate = values => {
  const errors = {};

  const itemVariantsErrors = [];
  if (values.item_variants) {
    values.item_variants.forEach((iv, index) => {
      const memberError = {};
      if (!iv.name && values.item_variants.length > 1) {
        memberError.name = 'Please fill in Variant Name';
      }
      if (iv.price > 99999999999) {
        memberError.price = 'Price must be less than 99.999.999.999';
      }
      if (Object.keys(memberError).length > 0) {
        itemVariantsErrors[index] = memberError;
      }
    });
  }
  if (itemVariantsErrors.length) {
    errors.item_variants = itemVariantsErrors;
  }

  return errors;
};

class ItemVariantModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isValidEcommerceColor: true,
      isValidEcommerceSize: true,
      isValidEcommerceMaterial: true,
      showOverLay: false,
    };
  }

  componentDidUpdate(prevProps) {
    const {
      itemForm: { is_ecommerce: isEcommerce },
      showItemVariantModal,
      dispatch,
    } = this.props;

    if (
      isEcommerce &&
      showItemVariantModal &&
      prevProps.showItemVariantModal !== showItemVariantModal
    ) {
      this.setState({
        isValidEcommerceColor: true,
        isValidEcommerceSize: true,
        isValidEcommerceMaterial: true,
        showOverLay: false,
      });
      dispatch(actItem.setCustomCategoryFashionConstructData());
      dispatch(change('modal_item_variants', 'custom_category_variant', true));
    }
  }

  handleIsValidTrue = labelName => {
    this.setState({
      [labelName]: true,
    });
  };

  _handleSubmit = () => {
    const {
      handleSubmit,
      dispatch,
      itemVariantForm: {
        item_variants: itemVariants,
        custom_category_variant: customCategoryVariant,
      },
      isItemVariantFormValid,
      ecommerceCategory,
    } = this.props;

    let isValidEcommerce = true;
    const isEcommerceFashion =
      customCategoryVariant &&
      ecommerceCategory.google_category_id === ECOMMERCECATEGORYID;
    if (isEcommerceFashion) {
      const {
        customCategoriesEcommerceFashion,
        customCategoriesEcommerceFashionData,
        // outletIds,
      } = this.props;
      // clevertapItem.inventoryItemVariantEcommerceModalConfirm({
      //   outletIds,
      //   numberOfVariants: itemVariants.length,
      // });
      const customCategoriesEcommerceFashionFilteredToShow = customCategoriesEcommerceFashion.filter(
        ({ name }) => name === 'color' || name === 'size' || name === 'material'
      );

      customCategoriesEcommerceFashionFilteredToShow.map(({ name }) => {
        const pluralName = `${name}s`;
        const labelName = `isValidEcommerce${name.charAt(0).toUpperCase() +
          name.slice(1)}`;
        if (
          customCategoriesEcommerceFashionData[[pluralName]].data.length === 0
        ) {
          this.setState({ [labelName]: false });
          isValidEcommerce = false;
        } else {
          this.setState({ [labelName]: true });
        }
      });
    }

    if (isEcommerceFashion && isValidEcommerce && isItemVariantFormValid) {
      const { customCategoriesEcommerceFashion } = this.props;

      const customCategoriesEcommerceFashionFilteredToShow = customCategoriesEcommerceFashion.filter(
        ({ name }) => name === 'color' || name === 'size' || name === 'material'
      );

      customCategoriesEcommerceFashionFilteredToShow.map(({ name }) => {
        const labelName = `unsetCustomCategoryFashion${name
          .charAt(0)
          .toUpperCase() + name.slice(1)}AllData`;
        dispatch(actItem[labelName]());
      });
      this._resetCustomCategoryFashionAllData();
      itemVariants.forEach(ivForm => {
        dispatch(arrayPush('item', 'item_variants', ivForm));
      });
    }

    if (isValidEcommerce) {
      handleSubmit();
    }
  };

  _handleOnChangeCustomCategoryVariant = () => {
    const {
      // outletIds,
      dispatch,
      itemVariantForm: {
        item_variants: itemVariants,
        custom_category_variant: customCategoryVariant,
      },
    } = this.props;
    if (customCategoryVariant) {
      // clevertapItem.inventoryItemVariantEcommerceToggle({
      //   isEnabled: false,
      //   outletIds,
      // });
      this._resetCustomCategoryFashionAllData();
      const ivNonEcommerce = itemVariants.filter(iv => !iv.is_generated);
      dispatch(arrayRemoveAll('modal_item_variants', 'item_variants'));
      if (ivNonEcommerce.length === 0) {
        const initialValue = {
          name: '',
          price: null,
          sku: '',
          in_stock: 0,
          stock_alert: 0,
          cogs: null,
          saved_cogs: false,
          is_saved: false,
          is_editable: true,
          is_new: true,
        };
        dispatch(
          arrayPush('modal_item_variants', 'item_variants', initialValue)
        );
      } else {
        for (let i = 0; i < ivNonEcommerce.length; i++) {
          dispatch(
            arrayPush('modal_item_variants', 'item_variants', ivNonEcommerce[i])
          );
        }
      }
    } else {
      // clevertapItem.inventoryItemVariantEcommerceToggle({
      //   isEnabled: true,
      //   outletIds,
      // });
    }
  };

  _renderModalBody = () => {
    const {
      ecommerceAttributes,
      ecommerceCategory,
      itemForm: { is_ecommerce: isEcommerce },
      itemVariantForm: { custom_category_variant: customCategoryVariant },
    } = this.props;
    const isEcommerceFashion =
      isEcommerce &&
      ecommerceCategory.google_category_id === ECOMMERCECATEGORYID;
    const {
      isValidEcommerceColor,
      isValidEcommerceSize,
      isValidEcommerceMaterial,
    } = this.state;

    return (
      isEcommerceFashion && (
        <div>
          <span className={styles['badge-variant-text']}>Variant Type</span>
          <div className={styles['badge-container']}>
            <TooltipCommerceStore placement="bottom" delay={200} name={'item'}>
              <div className={styles['toggle-badge-recommend']}>
                Mandatory For Online Store
              </div>
            </TooltipCommerceStore>
          </div>
          <div className={styles['custom-category-container']}>
            <span>
              Categorize your variant with variant type (e.g. Color, Size,
              Materials).
            </span>
            <Field
              component={Switch}
              name={`custom_category_variant`}
              disabled={false}
              onChange={this._handleOnChangeCustomCategoryVariant}
              type="checkbox"
            />
          </div>
          {customCategoryVariant && (
            <div>
              <div className="row">
                <div className="col-md-4">
                  <span className={styles['custom-variant-text']}>Type</span>
                </div>
                <div className="col-md-8">
                  <span className={styles['custom-variant-text']}>
                    Variant Name (separated by comma “,” e.g. S, M, L, XL)
                  </span>
                </div>
              </div>
              <FieldArray
                name="type_fields"
                component={TypeFieldArrayEcommerce}
                props={{
                  isEcommerceFashion,
                  ecommerceAttributes,
                  isValidEcommerceColor,
                  isValidEcommerceSize,
                  isValidEcommerceMaterial,
                  handleIsValidTrue: this.handleIsValidTrue,
                }}
              />
            </div>
          )}
        </div>
      )
    );
  };

  render() {
    const {
      showItemVariantModal,
      subscriptionDetail,
      ecommerceAttributes,
      itemForm: {
        is_sales_type_price: isSalesTypePrice,
        sales_type: salesType,
        is_ecommerce: isEcommerce,
      },
      ecommerceCategory,
    } = this.props;
    const isEcommerceFashion =
      ecommerceAttributes &&
      isEcommerce &&
      ecommerceCategory.google_category_id === ECOMMERCECATEGORYID;
    const modalBodyClassName = cx('modal-body', {
      body: isEcommerceFashion,
      'body-ecommerce': isEcommerceFashion,
    });
    return (
      <Modal
        show={showItemVariantModal}
        onHide={this._onCancel}
        dialogClassName={`modal-dialog ${styles.dialog}`}
      >
        <ModalHeader title={'Add Variant'} />
        <form>
          <Modal.Body bsClass={modalBodyClassName}>
            {this._renderModalBody()}
            <FieldArray
              name="item_variants"
              outletIds
              component={ItemVariantFieldArray}
              ecommerceAttributes={isEcommerceFashion}
              isEcommerceFashion={isEcommerceFashion}
              props={{
                ingredientSubscriptionDetail: subscriptionDetail,
                isSalesTypePrice,
                salesType,
              }}
            />
          </Modal.Body>
          <Modal.Footer>
            <span className="pull-left">
              <button
                className="btn btn-default"
                type="button"
                onClick={this._onCancel}
              >
                Cancel
              </button>
            </span>
            <span className="pull-right">
              <button
                className="btn btn-primary"
                onClick={this._handleSubmit}
                type="button"
              >
                Confirm
              </button>
            </span>
          </Modal.Footer>
        </form>
      </Modal>
    );
  }

  _resetCustomCategoryFashionAllData() {
    const { dispatch } = this.props;
    dispatch(actItem.unsetCustomCategoryFashionSizeAllDataNoSaga());
    dispatch(actItem.unsetCustomCategoryFashionColorAllDataNoSaga());
    dispatch(actItem.unsetCustomCategoryFashionMaterialAllDataNoSaga());
  }

  _onCancel = () => {
    const { dispatch, previousItemForm } = this.props;
    this._resetCustomCategoryFashionAllData();
    dispatch(actItem.onCancelItemVariantModal(previousItemForm));
  };
}

function mapStateToProps(state) {
  const { showItemVariantModal, previousItemForm } = state.library.item;
  const {
    ingredientSubscription: { subscriptionDetail },
  } = state.ingredients;
  const {
    customCategoriesEcommerceFashion,
    customCategoriesEcommerceFashionData,
    ecommerceCategory,
  } = state.library.item;

  const { outlets } = state.moka.user;
  return {
    showItemVariantModal,
    previousItemForm,
    subscriptionDetail,
    customCategoriesEcommerceFashion,
    customCategoriesEcommerceFashionData,
    itemVariantForm: getFormValues('modal_item_variants')(state),
    isItemVariantFormValid: isValid('modal_item_variants')(state),
    itemForm: getFormValues('item')(state),
    ecommerceCategory,
    outletIds: outlets.map(o => o.id),
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

ItemVariantModal.propTypes = {
  onSubmit: PropTypes.func,
  dispatch: PropTypes.func,
};

const mapForm = {
  form: 'modal_item_variants',
  touchOnBlur: false,
  touchOnChange: true,
  validate,
};

const connected = reduxForm(mapForm)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ItemVariantModal)
);

const mapFlagToProps = flags => {
  return {
    ecommerceAttributes: flags.ecommerceAttributes,
  };
};

export default withFeatureFlag(mapFlagToProps)(connected);
